/**
 * CourseLegend: a small key to an event's several courses, one quiet pill on the map in the style of its other chips:
 * each course a short stroke of its colour and its distance. A key, not a control: nothing in it takes a tap, so it
 * stays small and the map's controls keep their room. Each course's full name is there for assistive tech.
 */

import type { CSSProperties } from 'react'
import type { DrawnCourse } from './courses'
import './course-legend.css'

export function CourseLegend({ courses }: { courses: DrawnCourse[] }) {
  return (
    <ul className="course-legend" aria-label="Courses">
      {courses.map((course) => (
        <li key={course.key} className="course-legend__course">
          <span className="course-legend__swatch" style={{ '--course-color': course.color } as CSSProperties} aria-hidden="true" />
          {course.label === course.name ? (
            course.label
          ) : (
            <>
              <span aria-hidden="true">{course.label}</span>
              <span className="sr-only">{course.name}</span>
            </>
          )}
        </li>
      ))}
    </ul>
  )
}
